import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CursoPage } from '../pages/curso.page';

const CursoRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/curso' element={<CursoPage />} />
    </Routes>
  );
};

export { CursoRoutes };
